import React from "react";
import { CaregiverHandbookCard } from "../../UI";

const ProfileGoalsChapter = ({ chapter, status = "ready", onAddCta, addCtaLabel, onEntryAction }) => (
  <CaregiverHandbookCard
    chapter={chapter}
    status={status}
    onAddCta={onAddCta}
    addCtaLabel={addCtaLabel}
    onEntryAction={onEntryAction}
  />
);

export default ProfileGoalsChapter;
